import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Booking } from "@models/booking";
import { ModalService } from "@services/modal";
import { Subscription } from "rxjs/Subscription";
import { BookingEffects } from "@reducers/effects/booking";
import { BookingsStore } from "@store/bookings";
import { DeleteBookingParams } from "@services/booking";
import {
  DELETE_BOOKING,
  REMOVE_BOOKING,
  SAME_DAY_CANCEL_BOOKING,
  REPLACE_BOOKING
} from "@reducers/bookings";
import { Observable } from "rxjs/Observable";

@Component({
  selector: 'booking-removal-form',
  templateUrl: './booking-removal-form.pug',
})
export class BookingRemovalFormComponent implements OnInit, OnDestroy {

  public booking: Booking

  public bookingsSubscription: Subscription
  public bookingEffectsSubscription: Subscription

  private readonly CLOSE_ACTIONS: string[] = [
    REMOVE_BOOKING,
    REPLACE_BOOKING
  ]

  constructor(
    private store: Store<AppState>,
    private bookingEffects: BookingEffects,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.bookingsSubscription = this.store.select("bookingsReducer").subscribe(
      (s: BookingsStore) => {
        this.booking = s.editableBooking
      })

    this.setupEffectEvents()
  }

  clickedDeleteWithoutBan() {
    const params: DeleteBookingParams = {
      ban: false,
      booking: this.booking
    }

    this.store.dispatch({ type: DELETE_BOOKING, payload: params })
  }

  clickedDeleteWithBan() {
    const params: DeleteBookingParams = {
      ban: true,
      booking: this.booking
    }

    this.store.dispatch({ type: DELETE_BOOKING, payload: params })
  }

  clickedSameDayCancellation() {
    this.store.dispatch({ type: SAME_DAY_CANCEL_BOOKING, payload: this.booking.id })
  }

  setupEffectEvents() {
    this.bookingEffectsSubscription =
      Observable
        .merge(this.bookingEffects.remove)
        .filter((a: Action) => this.CLOSE_ACTIONS.includes(a.type))
        .subscribe(() => this.modalService.closeModal())
  }

  ngOnDestroy() {
    this.bookingsSubscription.unsubscribe()
    this.bookingEffectsSubscription.unsubscribe()
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/booking-removal-form.ts